import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    parent: {},
    background: {
      height: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: STYLE.COLOR.WHITE,
    },
    transparentBackground: {
      opacity: 0.7,
    },
    spinner: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: 'auto',
      zIndex: 99999,
    },
    loadingText: {
      position: 'fixed',
      top: 'calc(50% + 32px)',
      left: 0,
      right: 0,
      textAlign: 'center',
      zIndex: 99999,
      color: STYLE.COLOR.TEXT1,
      fontSize: 16,
    },
  }),
);
